<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h4`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm37.648 12.133a1 1 0 011 1V33.11H45a1 1 0 011 1v1.737a1 1 0 01-1 1h-1.352v4.786a1 1 0 01-1 1h-1.9a1 1 0 01-1-1v-4.786H30.5a1 1 0 01-1-1v-2.092a1 1 0 01.171-.56l10.54-15.621a1 1 0 01.829-.44h1.608zm-2.9 6.986l-5.982 8.991h5.982v-8.99z"/></svg>
</template>
<script>

export default {
  name: 'IconH4',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
